"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callable = void 0;
var functions_1 = require("firebase/functions");
/**
 *
 * @param schema object that contains request data and response data zod schema, and the function name
 * @param schema.req request data zod schema
 * @param schema.res response data zod schema
 * @param schema.name name of the function
 * @param func optional, insert firebase function builder here.
 * @returns
 */
var callable = function (schema, func) {
    /**
     *
     * @param data data type is what you define in schema.req
     * @param options optional, HttpsCallableOptions
     * @param options.timeout optional, Time in milliseconds after which to cancel if there is no response. Default is 70000.
     * @returns
     */
    var callable = function (data, options) {
        return (0, functions_1.httpsCallable)(func || (0, functions_1.getFunctions)(), schema.name, options)(data)
            .then(function (result) {
            var data = result.data;
            try {
                schema.res.parse(data);
            }
            catch (e) {
                return {
                    code: 'schema-out-of-sync',
                    message: 'please sync your schema',
                };
            }
            return { code: 'ok', data: result.data };
        })
            .catch(function (err) {
            return {
                code: err.code,
                message: err.message,
            };
        });
    };
    return callable;
};
exports.callable = callable;
